import React from 'react'
import * as functions from '../../helpers/Helpers'
import CheckoutItems from '../layout/CheckoutItems';
import ScanItemModal from '../layout/ScanItemModal';
import PriceCheckModal from '../layout/PriceCheckModal';
import Alert from 'react-bootstrap/Alert';

class Cashier extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            products: functions.getProducts(),
            show: false,
            barcode: '',
            currentSale: [],
            totalCost: 0,
            priceCheck: false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.findProduct = this.findProduct.bind(this);
        this.getTotalCost = this.getTotalCost.bind(this);

    }

    findProduct(barcode, sale){
        var foundProduct = this.state.products.filter(product => product.barcode === barcode);
        console.log("sale: " + sale)
        if (sale && foundProduct.length > 0){
            console.log(this.state.currentSale.length);
            if (this.state.currentSale.length === 0){
                this.setState({
                    currentSale : [foundProduct[0]],
                })
            }
             else{
                this.setState({
                    currentSale:
                        [...this.state.currentSale,
                            foundProduct[0]]
                })
             }
             this.getTotalCost();    
        }   
        else {
            console.log("item not found in inventory");
            if(this.state.priceCheck && foundProduct.length > 0){
                this.setState({priceCheck:false,
                show:false});
                alert("Price for " + foundProduct[0].name + "is £" + foundProduct[0].sale_price);
                
            }
        }     
    }

    getTotalCost = () => {
        var cost = parseFloat(0);
        this.state.currentSale.map((product, i) =>
                        cost = cost + parseFloat(product.sale_price)                        
                        );
                        console.log(cost);
                        return cost;

    }
    handleClick(e){
        e.preventDefault();
        //console.log(e.target.parentNode.innerText);
        if(e.target.parentNode.innerText === "Price Check"){
            this.setState({priceCheck:true});
        }
        this.setState({show:true});
    }

    handlePriceCheck(e){
        e.preventDefault();
        this.setState({priceCheck:true});
    }
    handleClose(e){
        //e.preventDefault();
        this.setState({show:false});
    }

    componentDidMount() {
        console.log(functions.getProducts())
    }
    componentDidUpdate(){

    }


    render() {
        return (
            <React.Fragment>
                <ScanItemModal props={this.props} state={this.state} show={this.state.show} handleClose={this.handleClose} 
                 handleSubmitItem={this.handleSubmitItem} findProduct={this.findProduct} scanItemsOnClick={this.props.scanItemsOnClick}
                 priceCheck={this.state.priceCheck} />
                 
                <div className='container'>
                    <div className='row'>
                        <h1>E-Till Screen</h1>
                    </div>
                    <div className="row">
                        <div className='col'>
                            <CheckoutItems currentSale={this.state.currentSale}/>
                        </div>
                        <div className='col'>
                        <div className="row">
                            <div className="col cashier-col">
                                <form onClick={this.handleClick}>
                                    <button className="btn btn-primary btn-lg cashier-btn">Start Scanning</button>
                                </form>
                            </div>
                            <div className="col cashier-col">
                                <form onClick={this.handleClick}>
                                    <button className="btn btn-primary btn-lg cashier-btn">Price Check</button>
                                </form>
                            </div>
                        </div>
                        <div className="row">
                            <div className="total-box">
                                <Alert  variant='success'>
                                    <h2>Current Total:</h2> <p className="sale-total">£{this.getTotalCost()}</p>
                                </Alert>    
                                
                            </div>    
                        </div> 
                        <div className="row">
                            <form onClick={this.handleCheckOut}>
                                <button className="btn btn-primary btn-lg checkout-btn">Check Out</button>
                            </form>
                        </div>

                        </div>
                    </div>
                    
                </div>
                
            </React.Fragment>
        );
    }
}

export default Cashier